import React from 'react';
import { CtaButton } from '../ui/cta-button';

// eslint-disable-next-line import/prefer-default-export
export function HeroContent() {
  return (
    <>
      <div id="hero-content" className="space-y-6">
        <h1 className="flex flex-col items-center md:items-start gap-1 md:gap-3">
          <span className="text-primary">Your Job Order.</span>
          <span className="text-tertiary">Multiple Recruiters Competing.</span>
          <span className="text-secondary">Across Every Domain.</span>
        </h1>
        <p className="text-xl md:text-3xl text-primary font-bold py-4">
          Post your role once — on your terms — and activate vetted recruiting agencies competing to
          deliver qualified candidates. Manage submissions in one transparent platform and pay only
          after a successful hire.
        </p>
      </div>

      <p className="text-xl text-primary md:max-w-xl font-medium leading-relaxed pb-4">
        <span className="font-bold">BoostHiring</span> is a recruiter marketplace where companies
        engage multiple agencies simultaneously to reach more qualified candidates and hire faster
        across the U.S. and Canada.
      </p>

      <p className="text-xl text-primary font-medium max-w-2xl leading-relaxed pb-4">
        Turn agencies into your on-demand hiring engine!
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 pt-4">
        <CtaButton href="/employer/signup" variant="primary">
          Post a Job Order
        </CtaButton>
        <span className="text-subtle font-medium text-sm">or</span>
        <CtaButton href="/recruiter/signup" variant="primary">
          Join as Agency
        </CtaButton>
      </div>
    </>
  );
}
